import { type DeliveryOrderDetail } from '@sg/graphql-schema';

import { type OrderingCart } from '@order/features/ordering';

import { type PartialLineItem } from '../../../graphql';

/**
 * The submission input is different from the cart response.
 * This converts the response into the input.
 */
export const getDeliveryParams = (
  orderChannel: OrderingCart<
    PartialLineItem,
    DeliveryOrderDetail
  >['orderChannel'],
  selectedTip: number,
  deliveryOrderDetail: DeliveryOrderDetail,
) => {
  return orderChannel === 'delivery' && deliveryOrderDetail.address?.id
    ? {
        addressId: deliveryOrderDetail.address.id,
        deliveryFee: deliveryOrderDetail.deliveryFee,
        vendor: deliveryOrderDetail.vendor,
        vendorRestaurantId: deliveryOrderDetail.vendorRestaurantId,
        tip: selectedTip,
      }
    : undefined;
};
